import { c as e, f as t, t as n, v as r } from "./store-DlwVEumz.js";
import { a as i } from "./dist-BCa5HPz5.js";
import { t as a } from "./page-EHBkKDUC.js";
import { t as o } from "./collectionIcon-4B-wWD3h.js";
import { useEffect as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { Box as u, EmptyState as d, FlexBox as f, Text as p } from "@dixa/lib-shared-habla";
import { Link as m } from "react-router-dom";
import { ampli as h } from "lib-shared-tracking";
var g = {
	gridWrapper: "_gridWrapper_3gmyc_1",
	grid: "_grid_3gmyc_1",
	kbCollectionCard: "_kbCollectionCard_3gmyc_24"
}, _ = ({ knowledgeBases: e }) => /* @__PURE__ */ c(f, {
	width: "100%",
	justifyContent: "center",
	padding: "400",
	className: g.gridWrapper,
	children: /* @__PURE__ */ c(u, {
		className: g.grid,
		children: e.map((e) => /* @__PURE__ */ c(v, { knowledgeBase: e }, e.collection.id))
	})
});
function v({ knowledgeBase: t }) {
	return /* @__PURE__ */ c(m, {
		to: e.internalKBCollection({ collectionId: t.collection.id }),
		style: { textDecoration: "none" },
		className: g.kbCollectionCard,
		"data-testid": "kb-collection-card",
		children: /* @__PURE__ */ l(f, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ l(f, {
				alignItems: "center",
				gap: "300",
				children: [/* @__PURE__ */ c(o, { color: t.theme.colors.icon }), /* @__PURE__ */ c(p.Heading, { children: t.title })]
			}), /* @__PURE__ */ c(f, { children: /* @__PURE__ */ c(p.Paragraph, { children: t.description }) })]
		})
	});
}
// src/pages/home/internalKBHome.tsx
function y() {
	let { loading: e, error: o, data: u } = r({
		variables: { languageId: t.En },
		fetchPolicy: "network-only"
	});
	s(() => {
		h.knowledgeInternalKbDashboardViewed({});
	}, []);
	let { reset: d } = n;
	if (s(d, [d]), e) return /* @__PURE__ */ c(i, {});
	if (o) throw o;
	let f = u?.knowledgeBases.results;
	return /* @__PURE__ */ l(a, { children: [/* @__PURE__ */ c(a.Head, { slotLeft: /* @__PURE__ */ c(a.HeadTitle, { title: "Internal knowledge bases" }) }), /* @__PURE__ */ l(a.Body, { children: [!f && /* @__PURE__ */ c(b, {}), !!f && /* @__PURE__ */ c(_, { knowledgeBases: f })] })] });
}
var b = () => /* @__PURE__ */ c(f, {
	height: "100%",
	width: "100%",
	justifyContent: "center",
	padding: "64px 0",
	children: /* @__PURE__ */ c(d, {
		icon: "file",
		title: "No knowledge bases",
		description: "Adjust your Collection settings to make them available in the Internal Knowledge Base, or create a new Collection."
	})
}), x = y;
export { x as default };

//# sourceMappingURL=home-B4fx8Ll9.js.map